var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.724 0.161627H3.19773C2.4754 0.161627 1.86343 0.412437 1.36181 0.914057C0.860185 1.41568 0.609375 2.01762 0.609375 2.71989V18.1297C0.609375 18.8319 0.860185 19.4389 1.36181 19.9505C1.86343 20.4622 2.4754 20.718 3.19773 20.718H23.724C24.4464 20.718 25.0583 20.4622 25.56 19.9505C26.0616 19.4389 26.3124 18.8319 26.3124 18.1297V2.71989C26.3124 2.01762 26.0616 1.41568 25.56 0.914057C25.0583 0.412437 24.4464 0.161627 23.724 0.161627ZM23.724 2.71989V3.38203L13.4609 11.3879L3.19773 3.38203V2.71989H23.724ZM3.19773 18.1297V6.63253L12.6784 14.0063C12.7787 14.0866 12.8991 14.1518 13.0395 14.202C13.18 14.2521 13.3204 14.2772 13.4609 14.2772C13.6013 14.2772 13.7418 14.2521 13.8822 14.202C14.0227 14.1518 14.1431 14.0866 14.2434 14.0063L23.724 6.63253V18.1297H3.19773Z",
    fill: "#EA519C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope-icon.7f9e97fb0e480892cddd879ffba43808.svg";
export { ForwardRef as ReactComponent };